import { Component, OnInit } from '@angular/core';

import { ModalService } from '../../shared/modules/modal';

import {
  ClosableModalWithErrorResponseModel
} from '../../shared/components/base/closable-modal-with-error-response-model';
import {
  AddCharacteristicErrorResponse,
  FunctionalAnalysesData,
  AddCharacteristicModalPayload
} from '../../shared/models';

import { NotificationService, FunctionalAnalysesService } from '../../shared/services';

import { TranslationConstants } from '../../shared/constants/translation';
import { FunctionalAnalysisObjectTypeEnum } from '../../shared/models/enums/functional-analysis-object-type-enum';

@Component({
  selector: 'add-characteristic',
  templateUrl: './add-characteristic-modal.component.html',
})
export class AddCharacteristicModalComponent
  extends ClosableModalWithErrorResponseModel<AddCharacteristicErrorResponse> implements OnInit {
  characteristic = new FunctionalAnalysesData();
  data: AddCharacteristicModalPayload;

  constructor(
    protected modalService: ModalService,
    protected notificationService: NotificationService,
    private _functionalAnalysesService: FunctionalAnalysesService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new AddCharacteristicErrorResponse();
    this.confirmationModalTitle = TranslationConstants.TRANSACTION_CLOSE_TITLE;
  }

  ngOnInit(): void {
    this.listenForErrorMessages();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.resetErrors();
    this._functionalAnalysesService.saveCharacteristic(
      this.data.resourceId,
      this.data.activeTab.id,
      this.data.type,
      this.characteristic
    ).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }

  getResourceLabelKey(): string {
    switch (this.data.type) {
      case FunctionalAnalysisObjectTypeEnum.Tba:
        return 'tba.tba_name';
      case FunctionalAnalysisObjectTypeEnum.UncontrolledTransaction:
        return 'transaction.transaction_id';
      case FunctionalAnalysisObjectTypeEnum.Pba:
        return 'tested_party.tested_party_name';
      default:
        return;
    }
  }
}
